import React, {useEffect, useState} from "react";


export default function AppearanceSelectHint () {
  const [closed, setClosed] = useState(false);
  const [{top, right}] = useState(() => {
    const burger = document.getElementsByClassName('nav__burger')[0];
    if (!(burger instanceof Element)) { return {top: 0, right: 0}; }
    const {top, left} = burger.getBoundingClientRect();
    const right = window.innerWidth - left;
    return {top: top + 10, right: right + 10};
  }, []);

  useEffect(() => {
    const timeoutId = window.setTimeout(() => { setClosed(true); }, 10000);
    return () => window.clearTimeout(timeoutId);
  }, []);

  if (closed) { return null; }

  return (
    <div className="appearance-select__hint" style={{top, right}}>
      <div className="appearance-select__hint__close" onClick={() => setClosed(true)}><i className="icon-close-01" /></div>
      <div className="appearance-select__hint__text">您可以在這裏找到切換<br />LIGHT / DARK 模式</div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/AppearanceSelect/AppearanceSelectHint.js